<template>
  <div>
    <div class="pt-4 fixed z-50 inset-0 w-full h-screen px-4 py-8 bg-gray-50">
      <div class="text-xxs text-nw-ash" v-if="pick.location != ''">Search Pick-up location*</div>
      <div class="relative">
        <input
          type="text"
          v-model="pick_location"
          placeholder="Search Pick-up location*"
          class="rounded-lg pl-12 pr-6 py-4 shadow-lg text-xs w-full focus:outline-none"
        />
        <div class="absolute top-2 left-4 mt-px" @click="closePop">
          <back-arrow-icon :width="'w-4'" :height="'h-4'"></back-arrow-icon>
        </div>
      </div>
      <div>
        <div
          class="border-b w-full px-6 py-4 text-xxs"
          v-for="(location, index) in pickup_location_search"
          :key="index"
          :class="{ 'pb-4': index != pickup_location_search.length - 1 }"
        >
          <div @click="selectPickUp(index)">
            {{ location.formatted_address }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackArrowIcon from '../icons/BackArrowIcon.vue'
export default {
  components: { BackArrowIcon },
  data() {
    return {
      pick: {
        location: '',
        coordinates: { lat: '', lng: '' },
        region_details: ''
      },
      pick_location: '',
      pickup_location_search: []
    }
  },
  watch: {
    pick_location(val) {
      if (val != '') {
        this.pick.location = val
        this.close_pickup_list = false
        this.getPickUpSearch(val)
      } else {
        this.pickup_location_search = []
        this.close_pickup_list = true
      }
    },
    pick: {
      deep: true,
      handler(val) {
        if (val.region_details != '') {
          var payload = {
            pick: val,
            pick_location: this.pick_location
          }
          this.$emit('pick-location', payload)
        }
      }
    }
  },
  methods: {
    closePop() {
      this.$emit('open-pop', false)
    },
    selectPickUp(index) {
      this.pick.coordinates.lat = this.pickup_location_search[index].geometry.location.lat()
      this.pick.coordinates.lng = this.pickup_location_search[index].geometry.location.lng()
      this.pick_location = this.pickup_location_search[index].formatted_address
      this.pickup_location_search = []
      this.pick.region_details = this.getClosestDistance(this.pick.coordinates)[0]
      var payload = {
        pick: this.pick,
        pick_location: this.pick_location
      }
      this.$emit('pick-location', payload)
      this.closePop()
    },
    async getPickUpSearch(place) {
      // const request = {
      //   query: place,
      //   fields: ['formatted_address', 'name', 'geometry']
      // }
      // // eslint-disable-next-line no-undef
      // var service = new google.maps.places.Place(document.getElementById('map'))
      // service.findPlaceFromQuery(request, (results, status) => {
      //   // eslint-disable-next-line no-undef
      //   if (status === google.maps.places.PlacesServiceStatus.OK && results) {
      //     this.pickup_location_search = results
      //   }
      // })

      try {
        // eslint-disable-next-line no-undef
        const { Place } = await google.maps.importLibrary('places')

        const { places } = await Place.searchByText({
          textQuery: place,
          fields: ['displayName', 'formattedAddress', 'location']
        })

        this.pickup_location_search = (places || []).map(p => ({
          name: p.displayName,
          formatted_address: p.formattedAddress,
          geometry: {
            location: p.location
          },
          place_id: p.id
        }))
      } catch (error) {
        console.error('Place search failed:', error)
        this.pickup_location_search = []
      }
    },
    getClosestDistance(val) {
      return this.$store.getters['arrange_details/getClosestDistance'](val)
    }
  }
}
</script>

<style></style>
